// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"fb4b61df","196":"77127869","197":"fb4b61df","921":"fb4b61df"}[chunkId] + ".chunk.css";
};